/**
 * Created by Andrey Popov on 4/2/21.
 */

const GiftContentView = cleverapps.Layout.extend({
    ctor: function (chatMessage) {
        this.chatMessage = chatMessage;

        const styles = cleverapps.styles.GiftContentView;

        this.chatMessage.parseGift();

        const contentWidth = Math.min(0.6 * cleverapps.resolution.getSceneSize().width, styles.width);
        const items = [];

        const bg = cleverapps.UI.createScale9Sprite(bundles.chat.frames.gift_bg);
        const mark = new cc.Sprite(bundles.chat.frames.checkmark_gift);
        const markHeight = this.chatMessage.isGiftTaken() ? mark.height : 0;
        let text, msg;

        let itemsFromCompletedExpedition = false;
        if (this.chatMessage.presents && this.chatMessage.presents.expedition) {
            itemsFromCompletedExpedition = cleverapps.meta.listActiveLocations().indexOf(this.chatMessage.presents.expedition) === -1;
        }

        let isUnknownUnit = false;
        if (this.chatMessage.presents && this.chatMessage.presents.unit) {
            const unit = this.chatMessage.presents.unit;
            isUnknownUnit = !(Families[unit.code] && Families[unit.code].units[unit.stage]);
        }

        let unavailableGift = false;
        if (this.chatMessage.presents && !itemsFromCompletedExpedition && !isUnknownUnit) {
            unavailableGift = Object.keys(this.chatMessage.presents).filter((type) => type !== "expedition").length === 0;
        }

        if (this.chatMessage.progress || this.chatMessage.metha || this.chatMessage.restoreProgressId || itemsFromCompletedExpedition || isUnknownUnit || unavailableGift) {
            if (this.chatMessage.metha) {
                if (this.chatMessage.metha.simple) {
                    const location = cleverapps.meta.getSelectedLocation();
                    const stage = parseInt(this.chatMessage.metha.simple.current);
                    if (!location.isComingSoonStage(stage)) {
                        text = cleverapps.UI.generateOnlyText(Messages.get("AdminSetMethaProgress.Text", { bgIndex: stage }), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
                    } else {
                        text = cleverapps.UI.generateOnlyText(Messages.get("AdminSetMethaProgress.Text.Unavailable"), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
                    }
                } else if (this.chatMessage.metha.farm) {
                    const buildingId = parseInt(this.chatMessage.metha.farm.building);
                    const building = cleverapps.meta.getSelectedLocation().buildings[buildingId];
                    const questId = parseInt(this.chatMessage.metha.farm.quest);

                    if (building && questId < building.quests.length) {
                        const buildingName = Messages.get(`building.${cleverapps.meta.getSelectedLocation().buildings[buildingId].name}`);
                        msg = Messages.get(questId > 0 ? "AdminSetFarmProgress.Text.Quest" : "AdminSetFarmProgress.Text", {
                            buildingName,
                            questName: Messages.get(building.quests[questId].title)
                        });
                        text = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
                    } else {
                        text = cleverapps.UI.generateOnlyText(Messages.get("AdminSetFarmProgress.Text.Unavailable"), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
                    }
                } else if (this.chatMessage.metha.home) {
                    const furnitureIndex = parseInt(this.chatMessage.metha.home.furniture);
                    const furniture = cleverapps.meta.getSelectedLocation().furniture[furnitureIndex];
                    const stage = parseInt(this.chatMessage.metha.home.stage);

                    if (furniture && stage < furniture.stages.length) {
                        const furnitureName = Messages.get(`building.${furniture.name}`);
                        msg = Messages.get(stage > 0 ? "AdminSetHomeProgress.Text.Stage" : "AdminSetHomeProgress.Text", {
                            furnitureName,
                            stageName: Messages.get(furniture.stages[stage].title)
                        });
                        text = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
                    } else {
                        text = cleverapps.UI.generateOnlyText(Messages.get("AdminSetHomeProgress.Text.Unavailable"), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
                    }
                }
            } else if (this.chatMessage.restoreProgressId) {
                text = cleverapps.UI.generateOnlyText(Messages.get("AdminRestoreProgress.Text", { userId: this.chatMessage.restoreProgressId }), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
            } else if (itemsFromCompletedExpedition) {
                text = cleverapps.UI.generateOnlyText(Messages.get("ItemsFromCompletedExpedition"), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
            } else if (isUnknownUnit) {
                text = cleverapps.UI.generateOnlyText(Messages.get("IsUnknownUnitGift"), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
            } else if (unavailableGift) {
                text = cleverapps.UI.generateOnlyText(Messages.get("AdminGiftsUnavailable"), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
            } else {
                const levelNo = cleverapps.humanReadableNumber(parseInt(this.chatMessage.progress.episode), parseInt(this.chatMessage.progress.level));
                text = cleverapps.UI.generateOnlyText(Messages.get("AdminSetProgress.Text", { levelNo }), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
            }

            text.setDimensions(contentWidth, 0);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

            bg.setContentSize(contentWidth + styles.bg.padding, Math.max(styles.minHeight, text.height + styles.bg.padding + markHeight));
            bg.addChild(text);
            text.setAlignment(bg.width / 2, bg.height / 2 + markHeight / 2);
            items.push(bg);
        } else if (this.chatMessage.presents || this.chatMessage.harvested) {
            const heroesGift = this.chatMessage.presents && this.chatMessage.presents.herolevels && this.chatMessage.presents.herolevels.length > 0;
            text = cleverapps.UI.generateOnlyText(Messages.get(heroesGift ? "AdminGiftsHeroes" : "AdminGiftsText"), cleverapps.styles.FONTS.CHAT_MESSAGE_TEXT);
            text.setDimensions(contentWidth, 0);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            items.push(text);

            let rewards = cleverapps.clone(this.chatMessage.presents, true);
            if (this.chatMessage.harvested) {
                rewards = {
                    unit: Object.keys(this.chatMessage.harvested).map((unitCode) => ({
                        code: unitCode,
                        amount: this.chatMessage.harvested[unitCode],
                        stage: 4
                    }))
                };
            }

            delete rewards.expedition;

            const rewardsList = new RewardsListComponent(rewards, {
                columns: heroesGift ? 3 : 2,
                font: cleverapps.styles.FONTS.CHAT_REWARD_COUNT_TEXT,
                textDirection: cleverapps.UI.HORIZONTAL,
                iconWrap: styles.prizeIcon,
                unitViewDummy: true
            });

            bg.setContentSize(contentWidth + styles.bg.padding, Math.max(styles.minHeight, rewardsList.height + markHeight + styles.bg.padding));
            bg.addChild(rewardsList);
            rewardsList.setAlignment(bg.width / 2, bg.height / 2 + markHeight / 2);
            items.push(bg);
        }

        if (this.chatMessage.isGiftTaken()) {
            mark.setAlignment(styles.checkmark);
            bg.addChild(mark);
        } else if (this.chatMessage.isApplicable()) {
            let noButton;
            if (this.chatMessage.progress !== undefined || this.chatMessage.metha !== undefined) {
                noButton = new cleverapps.UI.Button({
                    text: Messages.get("No"),
                    type: cleverapps.styles.UI.Button.Images.chat,
                    onClicked: function () {
                        cleverapps.chat.acceptGift(this.chatMessage, false);
                    }.bind(this),
                    textVariant: "strict_black",
                    width: styles.buttons.width,
                    height: styles.buttons.height
                });
            }

            const yesButton = new cleverapps.UI.Button({
                text: Messages.get(this.chatMessage.progress !== undefined ? "Yes" : "Accept"),
                type: cleverapps.styles.UI.Button.Images.chat,
                onClicked: function () {
                    cleverapps.chat.acceptGift(this.chatMessage, true);
                }.bind(this),
                textVariant: "strict_black",
                width: styles.buttons.width,
                height: styles.buttons.height
            });

            items.push(new cleverapps.Layout([noButton, yesButton], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            }));
        }

        this._super(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
    }
});

cleverapps.styles.GiftContentView = {
    width: 840,
    minHeight: 220,

    margin: 10,
    padding: {
        x: 10,
        y: 10
    },

    prizeIcon: {
        height: 130
    },

    buttons: {
        width: 200,
        height: 60
    },

    checkmark: {
        x: { align: "right", dx: -6 },
        y: { align: "bottom", dy: 10 }
    },

    bg: {
        padding: 20
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CHAT_REWARD_COUNT_TEXT: {
        size: 56,
        color: cleverapps.styles.COLORS.COLOR_BROWN,
        font: bundles.chat.urls.strict_font_ttf,
        name: "nostroke"
    }
});